import { gql, QueryResult, useQuery } from '@apollo/client'
import type {
  GetProfileCollectionsQuery,
  GetProfileCollectionsQueryVariables,
} from 'apollo-gql'
import inProfileCollectionsFragment from 'graphql/fragments/inProfileCollectionsFragment'
import { currentMarketIdVar } from 'graphql/reactive'

export const GET_PROFILE_COLLECTIONS = gql`
  query GetProfileCollections($marketId: ID!, $slug: String!) {
    market(id: $marketId) {
      id
      profile(slug: $slug) {
        id
        slug
        ...inProfileCollectionsFragment
      }
    }
  }
  ${inProfileCollectionsFragment}
`

type UseProfileInCollections = (
  slug: GetProfileCollectionsQueryVariables['slug'],
) => {
  profile?: GetProfileCollectionsQuery['market']['profile']
} & Pick<
  QueryResult<GetProfileCollectionsQuery, GetProfileCollectionsQueryVariables>,
  'loading' | 'error'
>

const useProfileInCollections: UseProfileInCollections = (slug) => {
  const marketId = currentMarketIdVar()

  const { loading, data, error } = useQuery<GetProfileCollectionsQuery>(
    GET_PROFILE_COLLECTIONS,
    {
      variables: { slug, marketId },
      fetchPolicy: 'cache-and-network',
    },
  )

  const profile = data?.market?.profile

  return { profile, loading, error }
}

export default useProfileInCollections
